module.exports = "<div class=\"app\" ng-class=\"$ctrl.appClass\"><navbar settings=\"$ctrl.app.settings\"></navbar><img ng-if=\"$ctrl.app.isUnRegistered\" style=\"-ms-interpolation-mode: bicubic; margin: auto;vertical-align: middle;display: inline-block;\" src=\"https://cdn.employeebgc.com/img/background/unregisteredClient.png\" width=\"100%\" height=\"100%\"/><div class=\"content\" ng-hide=\"$ctrl.app.isUnRegistered\"><div class=\"app-content\"><a class=\"off-screen-toggle hide\" href=\"\"></a><div ui-view=\"\"></div></div></div></div>"


//////////////////
// WEBPACK FOOTER
// ./client/app/app.pug
// module id = 29
// module chunks = 0